import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { LogOut, User } from "lucide-react";

const links = [
  { to: "/courses", label: "Courses" },
  { to: "/anatomy", label: "Anatomy" },
  { to: "/gallery", label: "Gallery" },
  { to: "/pricing", label: "Pricing" },
  { to: "/dashboard", label: "Dashboard" },
];

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-40 border-b border-border bg-background/80 backdrop-blur-xl">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3" data-testid="nav-logo">
          <div className="w-8 h-8 border border-foreground flex items-center justify-center">
            <span className="font-serif-display text-lg leading-none">P</span>
          </div>
          <div className="leading-tight">
            <div className="font-serif-display text-lg">Porcelain</div>
            <div className="font-mono-label text-[0.6rem] text-muted-foreground">Sculpting Academy</div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `text-sm transition-colors hover:text-primary ${isActive ? "text-primary" : "text-foreground"}`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          {user ? (
            <>
              <div className="hidden sm:flex items-center gap-2 text-sm" data-testid="nav-user-name">
                <User className="w-4 h-4" />
                {user.name}
                {user.is_admin && (
                  <Link to="/admin" className="font-mono-label text-foreground border border-foreground px-1.5 py-0.5 text-[0.55rem] hover:bg-foreground hover:text-background transition-colors" data-testid="nav-admin-link">ADMIN</Link>
                )}
                {user.is_premium && (
                  <span className="font-mono-label text-primary border border-primary px-1.5 py-0.5 text-[0.55rem]" data-testid="nav-pro-badge">PRO</span>
                )}
              </div>
              <button
                onClick={() => { logout(); navigate("/"); }}
                className="btn-outline-mono text-xs py-2 px-3 flex items-center gap-2"
                data-testid="nav-logout-button"
              >
                <LogOut className="w-3.5 h-3.5" /> Sign out
              </button>
            </>
          ) : (
            <>
              <Link to="/login" className="text-sm hover:text-primary transition-colors" data-testid="nav-login-link">Sign in</Link>
              <Link to="/signup" className="btn-oxblood text-sm" data-testid="nav-signup-button">Start learning</Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
